<template>
  <div class="card" :class="[{ 'lms': $config.project === 'lms', sale, 'annual-version': version === '1' && plan.slug === 'annual' }, plan.slug || 'free', $config.platform, additionalClass, showSpecialOffer && campaign ? `${campaign}-campaign` : '']">
    <div
      v-if="((sale && version === '0' && plan.slug === 'annual') || (plan.slug === 'annual' && campaign && showCampaignBanner && $store.state.campaign !== 'free-weeks-2024')) && saleTag"
      class="sale"
      :class="[{
        'got-what-it-takes': campaign === 'got-what-it-takes',
        'finance-courses-offer-label': campaign === 'finance-courses-offer'
      }, plan.source, $store.state.banners.active ? `${$store.state.banners.active.typeName}-label` : '']"
    >
      <span>{{ saleTag }}</span>
    </div>
    <div v-if="version === '1' && plan.slug === 'annual'" class="best">
      <span>Best Value</span>
    </div>
    <div v-if="$config.project === 'lms' && isCurrent" class="current">
      Current plan
    </div>
    <template v-if="plan.slug === 'annual'">
      <div v-if="(!campaign && (!sale || (!sale && !!$store.state.banners.active && $store.state.banners.active !== 3)))" :class="{ 'best-price': ['0', '2'].includes(version), 'best-value': version === '1' }">
        <span>{{ ['0', '2'].includes(version) ? (plan.source === 'referral' ? 'FRIEND REFERRAL' : 'Best Price') : 'Best Value' }}</span>
      </div>
      <div v-if="!!$store.state.banners.active && $store.state.banners.active.type === 3" class="sale" :class="$store.state.banners.active ? `${$store.state.banners.active.typeName}-label` : ''">
        <span>Limited Offer</span>
      </div>
      <component :is="heading" class="h6" :class="{ premium: (!['free-days-2023', 'free-weeks-2024'].includes(campaign) || $config.project === 'lms') }">
        Premium Annual
      </component>
      <span class="h2">
        <template v-if="plan.price">
          <span class="regular-price">{{ monthly.price | formatCurrency(currency, { minimumFractionDigits: 0 }) }}</span>
          <div class="current-price">
            {{ (billedPerMonth.discount || billedPerMonth.regular) | formatCurrency(currency, { minimumFractionDigits: digits((billedPerMonth.discount || billedPerMonth.regular)), dollarVariation: false }) }}
            <span :class="{ 'small-text': version === '1' }" class="body-1">{{ $store.state.laptop ? '/m' : '/month' | formatMonthPriceCurrency(currency) }}</span>
          </div>
        </template>
        <span v-else class="spin-loader">
          <IconSync class="spin" />
        </span>
      </span>
      <span class="caption">
        <span v-html="plan.billText" />
        <div v-if="plan.price && billedPerMonth.save && showSpecialOffer" class="save-label" :class="[{ 'simple-lms': $store.getters['auth/user'].simpleLms, 'sale-label': sale, 'new-label': version === '1' && plan.slug === 'annual' }, $store.state.banners.active ? $store.state.banners.active.typeName : '']"> {{ billedPerMonth.save }} </div>
      </span>
    </template>
    <template v-else-if="plan.slug === 'lifetime'">
      <span class="h6">Lifetime</span>
      <span class="h2">
        <template v-if="plan.price">
          <div class="current-price">
            {{ plan.price | formatCurrency(currency) }}
            <span v-if="0" :class="{ 'small-text': version === '1' }" class="body-1">/one-time</span>
            <span :class="{ 'small-text': version === '1' }" class="body-2">{{ '/m' | formatMonthPriceCurrency(currency) }}</span>
          </div>
        </template>
      </span>
      <span class="caption">Billed once</span>
    </template>
    <template v-else-if="$config.project === 'lms' && plan.slug === 'quarterly'">
      <span class="h6">Premium Quarterly</span>
      <span class="h2">
        <template v-if="plan.price">
          <span v-if="$config.project === 'lms'" class="regular-price">{{ monthly.price | formatCurrency(currency, { minimumFractionDigits: 0 }) }}</span>
          <div class="current-price">
            {{ (billedPerMonth.discount || billedPerMonth.regular) | formatCurrency(currency, { minimumFractionDigits: 0, dollarVariation: false }) }}
            <span class="body-1">{{ $store.state.laptop ? '/m' : '/month' | formatMonthPriceCurrency(currency) }}</span>
          </div>
        </template>
        <span v-else class="spin-loader">
          <IconSync class="spin" />
        </span>
      </span>
      <span class="caption">
        <span v-text="plan.billText" />
        <div v-if="plan.price && billedPerMonth.save" class="save-label" :class="{ 'sale-label': sale && $config.project === 'lms' }"> {{ billedPerMonth.save }} </div>
      </span>
    </template>
    <template v-else-if="plan.slug === 'monthly'">
      <component :is="heading" class="h6">
        Premium Monthly
      </component>
      <span class="h2">
        <div v-if="plan.price" class="current-price">
          {{ (billedPerMonth.discount || billedPerMonth.regular) | formatCurrency(currency, { minimumFractionDigits: 0, dollarVariation: false }) }}
          <span :class="{ 'small-text': version === '1' }" class="body-1">{{ $store.state.laptop ? '/m' : '/month' | formatMonthPriceCurrency(currency) }}</span>
        </div>
        <span v-else class="spin-loader">
          <IconSync class="spin" />
        </span>
      </span>
      <span class="caption">
        <span v-text="plan.billText" />
        <div v-if="sale && plan.price && billedPerMonth.save" class="save-label" :class="{ 'sale-label': sale && $config.project === 'lms' }"> {{ billedPerMonth.save }} </div>
      </span>
    </template>
    <template v-else-if="plan.slug === 'business'">
      <component :is="heading" class="h6">
        {{ version === '2' ? plan.billText : 'For Business' }}
      </component>
      <!-- <span class="h2">
        <template v-if="plan.price">
          <div class="current-price">
            {{ ((getBusinessPricePerUser / businessCounter) / 12) | formatCurrency({ sign: '$', value: 'USD' }, { minimumFractionDigits: 0, dollarVariation: false }) }}
            <span class="body-1">month/user</span>
          </div>
        </template>
        <span v-else class="spin-loader">
          <IconSync class="spin" />
        </span>
      </span> -->
      <!-- <div class="users-holder">
        <div class="users">
          <span class="caption">
            <span v-text="plan.billText" />
            <div v-if="plan.price && billedPerMonth.save" class="save-label" :class="{ 'sale-label': sale && $config.project === 'lms' }"> {{ billedPerMonth.save }} </div>
          </span>
          <small>2 users minimum</small>
        </div>
        <span class="users-count">
          <IconMinus :class="{ disabled: businessCounter <= 2 }" class="decrease" @click="counter('decrease')" />
          <input
            :value="businessCounter"
            type="text"
            class="counter"
            @keydown="setQuantity"
            @keyup="setQuantityInState"
          >
          <IconPlus :class="{ disabled: businessCounter >= 30 }" class="increase" @click="counter('increase')" />
          <div v-if="showBubble" class="bubble">
            If you want to purchase more than 30 subscriptions, please <span class="link-accent" @click="$store.dispatch('modals/open', { name: 'contact-sales' })">contact sales</span>
          </div>
        </span>
      </div> -->
      <span class="h2 business-card-title">
        Custom Price
      </span>
      <p class="business-card-subtitle">
        Corporate training tailored to your team’s size and needs.
      </p>
    </template>
    <template v-else>
      <div v-if="campaign === 'free-weeks-2024'" class="best-price">
        <span class="free-campaign-label">NOW ONLY</span>
      </div>
      <component :is="heading" class="h6" :class="{ premium: campaign === 'free-weeks-2024' }">
        Free
      </component>
      <span class="h2">
        <div class="current-price">
          {{ '0' | formatCurrency(currency, { minimumFractionDigits: 0, dollarVariation: false }) }}
          <span :class="{ 'small-text': version === '1' }" class="body-1">{{ '' | formatMonthPriceCurrency(currency) }}</span>
        </div>
      </span>
      <span v-if="version === '1' || campaign" class="caption">Try out the platform for free</span>
      <span v-else class="caption" v-html="version === '2' ? plan.billText : 'Try learning for free'" />
    </template>
    <!-- <hr> -->
    <template v-if="$config.project === 'site'">
      <button
        class="btn-primary btn-lg"
        :class="buttonClassSite"
        :data-event="trackingEventClick"
        @click="handleClick"
      >
        <span>{{ buttonTextSite }}</span>
      </button>
    </template>
    <template v-else>
      <button
        v-if="!$store.state.auth.user.activeSubscription"
        class="btn-primary"
        :class="[
          plan.id === 2 ? (sale && plan.source !== 'platform' ? 'btn-primary-purple-dark' : '') : '',
          plan.id !== 2 ? 'btn-hollow' : '',
          sale && plan.id !== 2 ? 'btn-sale' : '',
          plan.slug ? `subscribe-${plan.slug}` : '',
          $store.state.banners.active && plan.id === 2 ? `${$store.state.banners.active.typeName}-offer-btn` : '',
          campaign ? `campaign-btn btn-${campaign}` : ''
        ]"
        :disabled="$store.getters['subscriptions/active'].canceled"
        data-event="get_started.click"
        @click="handleClick"
      >
        <span>{{ buttonTextLMS }}</span>
      </button>
      <button
        v-else-if="plan.id < currentPlanId"
        class="btn-primary btn-hollow"
        :class="{ 'btn-sale': sale }"
        disabled
        data-event="upgrade.click"
        @click="handleClick"
      >
        Upgrade
      </button>
      <button
        v-else-if="plan.id === currentPlanId && sale && isExtendPlan && $store.getters['subscriptions/active'].activeSubscriptionProvider !== 'fastspring'"
        :disabled="sale >= $store.getters['subscriptions/active'].priceWoutTaxes || !!$store.getters['subscriptions/active'].changingState || $store.getters['subscriptions/active'].canceled"
        :class="[plan.id === 2 ? sale ? 'btn-primary btn-primary-sale' : 'btn-primary' : 'btn-primary-light', sale && plan.id !== 2 ? 'btn-sale' : '']"
        data-event="extend.click"
        @click="handleClick"
      >
        Extend plan
      </button>
      <button
        v-else-if="plan.id === currentPlanId"
        :class="[
          plan.id === 2 ? sale ? 'btn-primary btn-primary-sale' : 'btn-primary' : 'btn-primary-light',
          sale && plan.id !== 2 ? 'btn-sale' : '',
          campaign === 'finance-courses-offer' ? 'btn-cm' : ''
        ]"
        :disabled="$store.getters['subscriptions/active'].canceled"
        data-event="manage.click"
        @click="handleClick"
      >
        Manage plan
      </button>
      <button
        v-else-if="campaign === 'one-of-two-hundred-2024' && plan.slug !== 'quarterly'"
        class="btn-primary"
        :class="[
          campaign === 'one-of-two-hundred-2024' ? 'btn-one-of-two-hundred-2024' : ''
        ]"
        :disabled="$store.getters['subscriptions/active'].canceled"
        @click="handleClick"
      >
        Get {{ discount }}% OFF
      </button>
      <button
        v-else
        :disabled="!!$store.getters['subscriptions/active'].changingState || $store.getters['subscriptions/active'].canceled"
        class="btn-primary"
        :class="[plan.id === 2 ? sale && plan.source !== 'platform' ? 'btn-primary-sale' : '' : 'btn-hollow', sale && plan.id !== 2 ? 'btn-sale' : '', $store.state.banners.active && sale ? `btn-${$store.state.banners.active.typeName}` : '']"
        data-event="upgrade.click"
        @click="handleClick"
      >
        Upgrade
      </button>
    </template>
    <div
      class="details" :class="{ 'expanded': seeDetails, 'manage-plan-details': isCurrent && plan.slug === 'annual' }"
      @click="seeDetails = !seeDetails"
    >
      {{ seeDetails ? 'Hide Details' : 'See Details' }} <IconArrow />
    </div>
    <ul v-if="planSpecsV2 && planSpecsV2.length" :class="{ 'expanded': seeDetails }">
      <li
        v-for="(pp, idx) in planSpecsV2" :key="idx" :class="{ unselect: pp.notChecked && pp.notChecked.includes(plan.slug) }"
        v-html="pp.name"
      />
    </ul>
    <ul v-else-if="plan.slug !== 'business'" :class="{ 'expanded': seeDetails, 'manage-plan-list': isCurrent }">
      <li>
        {{ videoDuration }} hours of video <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li>
        {{ exercises }}+ Exercises <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li>
        Downloadables
      </li>
      <li>
        Self-paced lessons
      </li>
      <li>
        Resume builder
      </li>
      <li>
        Gamified features
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Leaderboard <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Career tracks <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Exams <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Certificates <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        New content <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Resume feedback <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Portfolio advice <span v-if="campaign === 'free-weeks-2024' && plan.free" class="free-campaign-label">NOW ONLY</span>
      </li>
      <li :class="{ 'unselect': campaign !== 'free-weeks-2024' && plan.free }">
        Personalized support
      </li>
    </ul>
    <ul v-else :class="{ 'expanded': seeDetails }">
      <li>{{ videoDuration }} hours of video</li>
      <li>{{ exercises }}+ Exercises</li>
      <li>Exams</li>
      <li>Certificates</li>
      <li>Admin dashboard</li>
      <li>Subscription management</li>
      <li>Task management</li>
      <li>Advanced reporting</li>
      <li>Data export</li>
      <li>Dedicated support</li>
      <li>Priority onboarding</li>
      <li>Access to talents</li>
      <li>Gamified features</li>
      <li>Leaderboard</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IconSync from '../assets/svg/icon-sync.svg?vue-component';
import IconArrow from '../assets/svg/icon-arrow.svg?vue-component';
import { calculateBilledPerMonth } from '../utils/helper';

export default {
  components: {
    IconSync,
    IconArrow,
  },
  props: {
    discount: { type: Number, required: false, default: 0 },
    plan: { type: Object, required: true },
    type: { type: String, required: false, default: 'info' },
    stats: { type: Object, required: true },
    campaign: { type: String, default: '', required: false },
    additionalClass: { type: Object, default: () => ({}), required: false },
    // eslint-disable-next-line vue/no-boolean-default
    showCampaignBanner: { type: Boolean, required: false, default: true },
    version: { type: String, default: '0' },
    heading: { type: String, default: 'h2', required: false },
    planSpecs: { type: Array, default: () => ([]) },
  },
  data() {
    return {
      seeDetails: ['free-days-2023', 'free-weeks-2024'].includes(this.campaign) || false,
      businessCounter: 2,
      showBubble: false,
      p: this.plan,
    };
  },
  computed: {
    ...mapState('subscriptions', ['currency']),
    trackingEventClick() {
      const v = this.version === '2' ? '_v1' : '';
      let event = `${this.plan.slug}${v}.click`;

      if (this.plan.free) {
        event = `for_free${v}.click`;
      }

      return event;
    },
    planSpecsV2() {
      if (this.planSpecs && this.planSpecs.length) {
        return this.planSpecs.filter((s) => s.plan.includes(this.p.slug) || s.plan.includes('all'));
      }

      return [];
    },
    isCurrentLifetime() {
      return this.$store.getters['subscriptions/active'].plan.id === 3;
    },
    isCurrent() {
      return this.$store.getters['auth/user'].id && this.$store.getters['subscriptions/active'].plan.id === this.p.id;
    },
    isExtendPlan() {
      return this.p.discountPrice < this.$store.getters['subscriptions/active'].priceWoutTaxes && this.isCurrent;
    },
    monthly() {
      return this.$store.getters['subscriptions/monthly'];
    },
    currentPlanId() {
      return this.$store.state.auth.user.activeSubscriptionPlan;
    },
    sale() {
      return this.p.discountPrice < this.p.price && this.p.source !== 'referral'
        && !this.isCurrentLifetime && ((this.$store.state.auth.user
        && (!this.currentPlanId
          || (this.currentPlanId && this.isExtendPlan)
          || (this.currentPlanId && this.p.source === 'platform')
          || (this.currentPlanId && this.$store.state.banners.active && this.$store.state.banners.active.typeName === 'loyalty')
          || (this.currentPlanId && this.currentPlanId < 2 && this.$store.state.banners.active && this.$store.state.banners.active.typeName === 'promo')))
          || this.$config.project === 'site');
    },
    teachable() {
      return this.$store.getters['auth/user'].activeSubscriptionProvider === 'teachable';
    },
    billedPerMonth() {
      const billedPerMonthValues = calculateBilledPerMonth(this.p, {
        active: this.$store.getters['subscriptions/active'],
        monthly: this.$store.getters['subscriptions/monthly'],
        quarterly: this.$store.getters['subscriptions/quarterly'],
        annual: this.$store.getters['subscriptions/annual'],
      }, this.sale);

      if (this.campaign && this.discount) {
        billedPerMonthValues.save = `Save ${this.discount}%`;
        billedPerMonthValues.get = `Get ${this.discount}% Off`;
      } else if (this.monthly.price > billedPerMonthValues.regular && this.version === '2' && this.$config.project === 'lms') {
        const save = Math.round(((this.monthly.price - billedPerMonthValues.regular) / this.monthly.price) * 100);
        billedPerMonthValues.save = `Save ${save === 19 ? 20 : save}%`;
        billedPerMonthValues.get = `Get ${save}% Off`;
      }

      return billedPerMonthValues;
      // const {
      //   id,
      //   discountPrice = 0,
      //   source,
      // } = this.p;

      // let { price } = this.p;

      // let finalPrice = !this.sale && !source ? price : (discountPrice || price);

      // const showCurrentBilling = this.p.discountPrice >= this.$store.getters['subscriptions/active'].nextChargePrice && this.isCurrent;

      // if (showCurrentBilling) {
      //   finalPrice = this.$store.getters['subscriptions/active'].nextChargePrice;
      //   price = this.$store.getters['subscriptions/active'].nextChargePrice;
      // }

      // let billedPerMonth = 0;
      // let billedPerMonthDiscount = 0;
      // let billedPerMonthDiscountPercent;
      // if (id === this.$store.getters['subscriptions/monthly'].id) {
      //   billedPerMonth = price;
      //   billedPerMonthDiscount = finalPrice;
      //   billedPerMonthDiscountPercent = Math.floor((1 - (finalPrice / price)) * 100);
      // } else if (id === this.$store.getters['subscriptions/quarterly'].id) {
      //   billedPerMonth = price / 3;
      //   billedPerMonthDiscount = finalPrice / 3;
      //   const monthly = this.$store.getters['subscriptions/monthly'];
      //   const monthlyPrice = monthly.price * 3;
      //   billedPerMonthDiscountPercent = Math.floor((1 - (finalPrice / monthlyPrice)) * 100);
      // } else if (id === this.$store.getters['subscriptions/annual'].id) {
      //   billedPerMonth = price / 12;
      //   billedPerMonthDiscount = finalPrice / 12;
      //   const monthly = this.$store.getters['subscriptions/monthly'];
      //   const monthlyPrice = monthly.price * 12;
      //   billedPerMonthDiscountPercent = Math.round((1 - (finalPrice / monthlyPrice)) * 100);
      // }

      // billedPerMonthDiscountPercent = billedPerMonthDiscountPercent === 19 ? 20 : billedPerMonthDiscountPercent;

      // if (showCurrentBilling) {
      //   billedPerMonthDiscountPercent = 0;
      // }

      // if (this.campaign && this.discount) {
      //   billedPerMonthDiscountPercent = this.discount;
      // }

      // return {
      //   regular: Number.isInteger(billedPerMonth) ? billedPerMonth : billedPerMonth.toFixed(2),
      //   discount: Number.isInteger(billedPerMonthDiscount) ? billedPerMonthDiscount : billedPerMonthDiscount.toFixed(2),
      //   save: billedPerMonthDiscountPercent ? `Save ${billedPerMonthDiscountPercent}%` : null,
      //   get: billedPerMonthDiscountPercent ? `Get ${billedPerMonthDiscountPercent}% Off` : null,
      // };
    },
    buttonTextSite() {
      if (['transform-your-future-2024', 'most-wanted-2024'].includes(this.campaign)) {
        return 'Get Started';
      }

      if (this.campaign && this.discount && this.plan.slug === 'annual') {
        return `Get ${this.discount}% OFF`;
      }

      if (this.plan.slug === 'business') {
        return 'Request a Demo';
      }

      return 'Get Started';
    },
    buttonTextLMS() {
      if (['transform-your-future-2024', 'most-wanted-2024'].includes(this.campaign)) {
        return 'Get Started';
      }

      if (this.$store.state.banners.active && !this.campaign && this.plan.slug === 'annual') {
        return this.billedPerMonth.get;
      }

      if (this.campaign && this.discount && this.plan.slug === 'annual') {
        return `Get ${this.discount}% OFF`;
      }

      return 'Get Started';
    },
    buttonClassSite() {
      const classes = [];

      if (this.campaign) {
        classes.push(`campaign-btn btn-${this.campaign}`);
      }

      if (!this.campaign) {
        if (this.sale && this.version !== '1') {
          classes.push('btn-primary-purple-dark');
        }
      }

      if (this.plan.free) {
        classes.push('free-btn');
      }

      if (this.plan.slug) {
        classes.push(`subscribe-${this.plan.slug}`);
      }

      if ((!this.sale && ((this.$config.platform === 'ds' && this.version !== '2') || this.plan.slug !== 'annual')) || (this.campaign === 'free-weeks-2024' && !this.plan.free)) {
        classes.push('btn-hollow');
      }

      return classes;
    },
    videoDuration() {
      let vd = this.stats.rounded.videoDuration;

      if (this.p.free && this.campaign !== 'free-weeks-2024') {
        vd = this.stats.rounded.freeVideoDuration;
      }

      return vd;
    },
    exercises() {
      let e = this.stats.rounded.exercises;

      if (this.p.free && this.campaign !== 'free-weeks-2024') {
        e = this.stats.rounded.freeExercises;
      }

      return e;
    },
    getBusinessPricePerUser() {
      let saving = 0;
      for (let i = 1; i <= this.businessCounter; i += 1) {
        saving += this.getTierPrice(i);
      }

      return saving;
    },
    saleTag() {
      // modify for current campaign
      if (this.campaign) {
        if ([
          'transform-your-future-2024',
          'most-wanted-2024',
          'future-proof-2024',
          'fast-track-2024',
          'learn-data-and-ai',
          'learn-finance',
          'black-friday-2024',
          'cyber-monday-2024',
          'jumpstart-2025',
        ].includes(this.campaign)) {
          return 'Limited-Time Offer';
        }

        return 'Special Offer';
      }

      if (this.$store.state.banners.active && this.$store.state.banners.active.type !== 2) {
        const labels = {
          1: 'Special Offer',
          3: 'Limited Offer',
          4: 'Refer a Friend',
          5: 'Loyalty Offer',
        };
        return labels[this.$store.state.banners.active.type];
      }

      if (this.p.source === 'benefit') {
        return 'BENEFIT OFFER';
      }

      if (this.p.source === 'platform') {
        return 'Special Offer';
      }

      return 'SALE';
    },
    showSpecialOffer() {
      if (this.plan.slug === 'annual' && this.$config.project === 'lms' && this.version === '2') {
        return true;
      }

      if (this.showCampaignBanner && this.$store.getters['auth/user'].id && this.plan.slug === 'annual') {
        return true;
      }

      if (!this.$store.getters['auth/user'].id) {
        return true;
      }

      return false;
    },
  },
  watch: {
    plan(v) {
      this.p = v;
    },
  },
  mounted() {
    this.$root.$on('emit-click', (e) => {
      const increase = this.$el.querySelector('.increase');
      const tooltip = this.$el.querySelector('.bubble');
      if (increase && !increase.contains(e.target) && tooltip && !tooltip.contains(e.target)) {
        this.showBubble = false;
      }
    });
  },
  methods: {
    counter(type) {
      if (type === 'increase') {
        this.businessCounter = Number(this.businessCounter);
        this.businessCounter += 1;
        if (this.businessCounter >= 30) {
          this.showBubble = true;
          this.businessCounter = 30;
        }
      } else if (type === 'decrease') {
        this.businessCounter = Number(this.businessCounter);
        this.businessCounter -= 1;
      }
    },
    async handleClick() {
      if ((this.isCurrent || this.teachable) && !this.isExtendPlan) {
        return this.$router.push('/settings/billing/subscription/');
      }

      if (this.p.name) {
        this.$store.dispatch('dataLayer/addEvent', { event: 'addToCart', value: { ...this.p, planTitle: this.p.title, currency: this.p.currency.value } });

        if (this.$store.getters['auth/user'].activeSubscriptionProvider === 'fastspring') {
          this.$store.dispatch('subscriptions/checkout', { plan: this.p.name });
        } else {
          const plan = this.p.shortTitle.toLowerCase();
          const quantity = this.businessCounter && this.p.slug === 'business';
          if (this.p.slug === 'business') {
            return this.$router.push({ path: '/request-demo/' });
          }
          if (this.$config.project === 'site' && !this.campaign) {
            return this.$router.push({ path: '/checkout/', query: { plan, quantity: quantity ? this.businessCounter : undefined } });
          }
          window.location.href = `${this.$config.siteUrl}/checkout/?plan=${plan}${quantity ? `&quantity=${this.businessCounter}` : ''}${this.p.coupon ? `&coupon=${this.p.coupon}` : ''}`;
        }
      }

      return this.$emit('subscribe');
    },
    getTierPrice(q) {
      if (q >= 3 && q <= 5) {
        return 313.2;
      }

      if (q >= 6 && q <= 10) {
        return 278.4;
      }

      if (q >= 11 && q <= 20) {
        return 243.6;
      }

      if (q >= 21 && q <= 30) {
        return 226.2;
      }

      if (q >= 31 && q <= 120) {
        return 99.00;
      }

      return 348;
    },
    setQuantity(e) {
      const quantity = +e.key;

      if (!quantity && e.key !== 'Backspace' && e.key !== 'Delete' && quantity !== 0 && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') {
        e.preventDefault();
      }
    },
    setQuantityInState(e) {
      setTimeout(() => {
        let q = +e.target.value;

        if (q > 30) {
          q = 30;
        } else if (q < 2) {
          q = 2;
        }

        // eslint-disable-next-line no-param-reassign
        e.target.value = q;
        this.businessCounter = q;
        if (this.businessCounter < 30) {
          this.showBubble = false;
        }
      }, 500);
    },
    digits(v) {
      return Number.isInteger(v) ? 0 : 2;
    },
  },
};
</script>

<style scoped lang="scss">

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.card {
  height: 100%;
  background-color: var(--main-light-shade-1);
  border-radius: 10px;
  box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
  color: var(--main-dark-shade-0);
  padding: var(--spacing-28);
  position: relative;
  z-index: 1;

  &.v2 {
    &.annual {
      &:after {
        content: '';
        position: absolute;
        z-index: -1;
        top: -18px;
        right: 0;
        bottom: -18px;
        left: 0;
        display: block;
        background-color: var(--main-light);
        border-radius: 11px;
        box-shadow: 0 3px 12px 0 #00A4B2;
      }

      .h2 {
        font-size: 16px;
        margin-top: 8px;
        margin-bottom: 8px;

        .regular-price {
          position: relative;
          margin-top: 0;
        }

        .current-price {
          text-align: left;
        }
      }

      .caption {
        justify-content: space-between;

        .save-label {
          position: static;
          height: 28px;
          line-height: 28px;
          font-size: 14px;
          color: var(--main-dark);
          background-color: var(--main-yellow);
        }
      }
    }

    &.quarterly {
      .caption {
        justify-content: space-between;

        .save-label {
          position: static;
        }
      }
    }

    &.business {
      .h6 {
        color: var(--main-light-shade-3);
        text-align: left;
      }

      .business-card-title {
        text-align: left;
        margin-top: 28px;
        font-size: 28px;
      }

      .business-card-subtitle {
        text-align: left;
      }
    }

    .best-price {
      top: -36px;

      span {
        background-color: var(--main-yellow);
        font-weight: 600;
        line-height: 30px;
        font-size: 14px;
        text-transform: uppercase;
        color: var(--main-dark);
        text-align: center;
        width: 124px;
        height: 30px;
      }
    }

    .h6 {
      display: block;
      text-align: left;
      color: var(--main-dark-light-2);
      font-size: 21px;
      line-height: 24px;

      &.premium {
        color: var(--accent-shade-2);
        font-weight: 600;
        font-size: 24px;
        line-height: 24px;
        margin-bottom: 0;
      }
    }

    .caption {
      display: flex;
      align-items: center;
      text-align: left;
      color: var(--main-dark-light-4);
      font-size: 12px;
      line-height: 18px;
      height: 36px;
    }

    .h2 {
      display: block;
      margin-top: 20px;

      .regular-price {
        font-size: 12px;
      }

      .current-price {
        font-size: 32px;
        line-height: 36px;
        display: block;
        white-space: nowrap;

        .body-1 {
          margin-left: -8px;
        }
      }
    }

    .btn-primary {
      margin-bottom: 0;
      height: 64px;
    }

    ul {
      display: none;

      li.unselect {
        color: var(--main-dark);
      }
    }

    &.lms {
      padding-top: 36px;

      .best-price {
        top: -33px;
      }

      .h6 {
        &,
        &.premium {
          font-size: 21px;
          text-align: center;
        }
      }

      .current {
        font-size: 12px;
        position: absolute;
        margin-top: -20px;
        line-height: 20px;
        left: 0;
        right: 0;
        text-align: center;
      }

      &.annual {
        .current {
          margin-top: -32px;
        }

        .h6 {
          position: relative;
          top: -12px;
        }
      }

      &:not(.annual) .h2 {
        margin-top: 28px;
      }

      .h2 {
        line-height: normal;
      }

      .btn-primary {
        height: 58px;
      }
    }
  }

  &.lms:not(.v2) {
    padding: var(--spacing-48) var(--spacing-32) var(--spacing-32) var(--spacing-32);

    .h6 {
      font-size: 21px;
    }

    .h2 {
      font-size: 38px;
      margin-top: var(--spacing-26);
      margin-bottom: var(--spacing-4);
      position: relative;

      .regular-price {
        display: block;
        height: 23px;
        margin-top: 0;
        margin-bottom: 2px;
        top: -16px;
        font-weight: 500;
      }

      .current-price {
        line-height: 44px;

        span {
          line-height: 27px;
          margin-left: 0;
          padding: 0;
        }
      }

      .body-1 {
        vertical-align: baseline;
        margin-left: -8px;
        font-size: 16px;
        font-weight: 400;
      }

      .body-2 {
        display: none;
      }
    }

    .caption {
      height: 24px;
    }

    .current {
      position: absolute;
      top: 28px;
      font-size: 12px;
      color: var(--main-dark-light-3);
    }

    hr {
      margin-top: var(--spacing-24);
      margin-bottom: var(--spacing-24);
    }
  }

  &:not(.lms) {
    .btn-hollow {
      height: 58px;
      border-width: 2px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &.annual-version {
    background: var(--main-dark-shade-2);
    color: var(--main-light);

    .regular-price {
      color: var(--main-dark-shade-4) !important;
    }

    .h6 {
      color: var(--main-dark-shade-4) !important;
    }

    .btn-lg {
      background: #DFB726;
      border: unset;
      color: var(--main-light);

      &:hover {
        background-color: var(--main-yellow);
        color: var(--main-light);
      }
    }

    ul {
      li {
        background-image: url("../assets/svg/icon-checked-yellow.svg");
        image-rendering: -webkit-optimize-contrast;
      }
    }
  }

  &.business {
    background: var(--main-dark-shade-2);
    color: var(--main-light);
    border-radius: 10px;

    .h6 {
      color: var(--main-dark-shade-4);
    }

    .business-card-title {
      font-size: 25px;
      margin-bottom: 0;
    }

    .business-card-subtitle {
      margin-top: var(--spacing-6);
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: var(--main-dark-shade-4);
      margin-bottom: 0;
    }

    .current-price {
      width: 100%;
    }

    &:not(.v2) ul {
      li {
        background-image: url("../assets/svg/icon-checked-yellow.svg");
        image-rendering: -webkit-optimize-contrast;
      }
    }

    .users-holder {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .users {
        .caption {
          padding-top: 0;

          span {
            font-weight: 500;
            color: var(--main-light-shade-4);
          }
        }

        small {
          font-size: 12px;
          color: var(--main-light-shade-4);
          opacity: 0.7;
        }
      }

      .users-count {
        display: flex;
        align-items: center;
        position: relative;

        .decrease,
        .increase {
          cursor: pointer;
        }

        .decrease {
          &.disabled {
            // color: #565E6A;
            // border: 1px solid #565E6A;
            // background: transparent;
            pointer-events: none;

            path,
            circle {
              stroke: #565E6A;
            }
          }
        }

        .counter {
          padding: var(--spacing-4);
          text-align: center;
          background: #4B5461;
          border: 1px solid #565E6A;
          box-sizing: border-box;
          border-radius: 3px;
          width: 44px;
          height: 28px;
          font-weight: 500;
          font-size: 18px;
          line-height: 110%;
          color: var(--main-light);
          margin: 0 6px;
          -moz-appearance: textfield;

          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        }

        .bubble {
          padding: var(--spacing-18) var(--spacing-16) var(--spacing-24);
          background: var(--main-light);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          position: absolute;
          right: 0;
          transform: translateX(calc(50% - 10px));
          bottom: 36px;
          width: 230px;
          font-size: 14px;
          line-height: 130%;
          text-align: center;
          color: var(--main-dark-shade-0);

          .link-accent {
            cursor: pointer;
          }

          &:before {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            bottom: -12px;
            left: 50%;
            margin-left: -7px;
            border-style: solid;
            border-color: var(--main-light) transparent transparent transparent;
            border-width: 6px 7px 6px 7px;
            z-index: 2;
          }
        }
      }
    }

    .subscribe-business {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 58px;
      margin-top: var(--spacing-26);
      background: transparent;
      border: 2px solid var(--main-yellow);
      color: var(--main-yellow);
      border-radius: 5px;

      &:hover {
        background-color: var(--main-yellow);
        color: var(--main-light);
      }

      &:active {
        background-color: var(--main-yellow-shade-1);
        border-color: var(--main-yellow-shade-1);
      }
    }

    &.free-campaign,
    &.black-friday-campaign {
      ul {
        li {
          background-image: url("../assets/svg/icon-checked.svg");
        }
      }
    }
  }

  &.black-friday-campaign,
  &.finance-courses-offer-campaign {
    border-radius: 0;

    .btn-primary,
    .btn-cm {
      border-radius: 0;

      &:hover,
      &:active {
        color: var(--main-light);
      }
    }
  }

  &.black-friday-campaign.annual {
    filter: drop-shadow(-8px -8px 0 #E75CEE) drop-shadow(8px 8px 0 var(--extreme-blue-2));

    .btn-primary {
      background: var(--extreme-yellow);
      color: var(--main-dark-shade-0);
      border: 2px solid var(--main-dark);

      &:hover,
      &:active {
        background-color: #FF8;
      }
    }

    ul {
      li {
        background-image: url("../assets/svg/icon-checked-purple.svg");
      }
    }

    .caption {
      .save-label {
        background: rgba(25, 95, 245, 0.2);
        color: var(--extreme-dark-blue);
      }
    }
  }

  &.finance-courses-offer-campaign.annual {
    .btn-primary {
      background: #FCFC53;
      border: 3px solid #000C1F;
      color: var(--main-dark-shade-0);

      &:hover,
      &:active {
        background-color: #FF8;
      }
    }

    ul {
      li {
        background-image: url("../assets/svg/icon-checked-blue.svg");
      }
    }

    .caption {
      .save-label {
        background: rgba(252, 30, 150, 0.2);
        color: var(--extreme-fucsia);
      }
    }
  }

  &.finance-courses-offer-campaign.lms {
    &.annual {
      .best-price {
        display: none;
      }

      .caption {
        .save-label {
          height: 28px;
          color: #FC1E96;
        }
      }

      .btn-primary {
        border-width: 3px;
      }
    }

    .btn-primary {
      height: 40px;
      border-width: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &.one-of-two-hundred-2024-campaign,
  &.one-of-two-hundred-2024-campaign.lms {
    .h2 {
      .current-price {
        .body-1 .body-2 {
          font-size: 18px !important;
        }
      }
    }

    .caption {
      padding: 0;

      span {
        font-weight: 500;
      }
    }

    .campaign-btn {
      border: 2px solid var(--accent-shade-1);
      color: var(--accent-shade-1);

      &:hover {
        color: var(--main-light);
      }
    }

    &.annual {
      border-radius: 10px;

      .sale span {
        padding: var(--spacing-4) 23px;
        background-color: var(--c-oth-1);
        border-radius: 5px;
      }

      .h2 {
        .current-price {
          .body-1 .body-2 {
            font-size: 18px !important;
          }
        }
      }

      .caption .save-label {
        background: var(--c-oth-1) !important;
        letter-spacing: 0.02em;
        color: var(--true-white) !important;
      }

      ul li {
        background-image: url("../assets/svg/icon-check-extreme-fucsia.svg");
      }

      &.fa ul li {
        background-image: url("../assets/svg/fa/fa-icon-checked-blue.svg");
      }

      .button-holder.annual {
        position: relative;
        z-index: 1;
        top: 2px;

        .btn-shadow {
          display: block;
          position: relative;

          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 62px;
            left: 0;
            width: calc(100% - 26px);
            height: 0;
            border-left: 13px solid transparent;
            border-right: 13px solid transparent;
            border-top: 10px solid #B7B700;
          }

          &:after {
            content: '';
            display: block;
            position: absolute;
            top: 54px;
            left: 10px;
            width: calc(100% - 20px);
            height: 20px;
            border-radius: 7px;
            background: #B7B700;
          }

          &.hide {
            display: none;
          }
        }

        &.manage {
          top: 22px;
        }
      }

      .btn-3d {
        margin-top: var(--spacing-8);
        background: var(--extreme-yellow);
        border: none;
        top: 0;
        border-radius: 6px;
        color: var(--main-dark);
        position: absolute;
        line-height: 100%;
        text-align: center;
        letter-spacing: 0.02em;
        transition-duration: 320ms;

        &:before {
          content: '';
          height: 100%;
          width: 20px;
          position: absolute;
          left: -20px;
          background: var(--main-light-shade-1);
        }

        &:after {
          content: '';
          display: block;
          height: 100%;
          width: 20px;
          position: absolute;
          right: -20px;
          background: var(--main-light-shade-1);
        }

        &:hover {
          background: #E7E700;
        }

        &:active {
          transition-duration: 50ms;
          background: #E7E700;
          color: var(--main-dark);
          width: calc(100% - 20px);
          transform: translate(10px, 8px);
        }

        &:disabled {
          opacity: 1;
          background: var(--main-yellow-light-2);
        }
      }
    }

    &.business {
      .h2 {
        .current-price {
          .body-1 .body-2 {
            line-height: 19px;
            overflow-wrap: break-word;
            width: 76px;
          }
        }
      }

      .business-card-subtitle {
        margin-top: var(--spacing-10);
      }

      .users-holder {
        .users {
          small {
            display: block;
            font-weight: 500;
          }
        }
      }

      .campaign-btn {
        margin-top: var(--spacing-22);
        border-color: var(--main-yellow);
        color: var(--main-yellow);
        line-height: 100%;

        &:hover {
          color: var(--main-light);
          background-color: var(--main-yellow);
        }

        &:active {
          color: var(--main-light);
          border-color: var(--main-yellow-shade-1);
          background-color: var(--main-yellow-shade-1);
        }
      }
    }
  }

  &.one-of-two-hundred-2024-campaign.annual {
    &.lms {
      ul {
        &.manage-plan-list {
          padding-top: var(--spacing-48);
        }
      }
    }

    .btn-primary {
      position: relative;
      width: 100%;
      max-width: 327px;
      background: var(--c-oth-2);
      box-shadow: none;
      line-height: 18px;
      letter-spacing: 0.02em;
      cursor: pointer;
      color: var(--main-dark);
      transition: all 150ms ease;
      border-radius: 7px;
      border-color: var(--c-oth-2);
      top: 0;

      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 3px;
        bottom: -9px;
        width: calc(100% - 22px);
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 10px solid #B7B700;
        z-index: -1;
        transition: all 150ms ease;
      }

      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -11px;
        left: 10px;
        background: #B7B700;
        border-radius: 10px;
        width: calc(100% - 20px);
        height: 10px;
        z-index: -1;
        transition: all 150ms ease;
      }

      &:not(:disabled):active {
        box-shadow: none;
        transform: none;
        border-color: transparent;
      }

      &:not(:disabled):hover {
        top: 10px;
        color: var(--main-dark);

        &:before,
        &:after {
          bottom: 1px;
        }
      }
    }
  }

  &.got-what-it-takes-campaign {
    .caption {
      font-weight: 500;
      height: 28px;
      padding: 0;
    }

    .h6 {
      margin-top: var(--spacing-14);
      display: block;
    }

    .btn-got-what-it-takes {
      height: 58px;
      margin: var(--spacing-16) 0;
      border: 2px solid var(--accent-shade-1);

      &.subscribe-annual {
        background: var(--main-yellow);
        border: none;
        color: var(--main-dark);

        &:hover {
          color: var(--main-dark);
          background-color: var(--main-yellow-shade-1);
        }

        &:active {
          color: var(--main-dark);
          background-color: var(--main-yellow-shade-2);
        }
      }

      &.subscribe-business {
        border: 2px solid var(--main-yellow);
        color: var(--main-yellow);

        &:hover {
          color: var(--main-dark);
          background-color: var(--main-yellow);
        }

        &:active {
          background-color: var(--main-yellow-shade-1);
          border-color: var(--main-yellow-shade-1);
        }
      }
    }

    &.annual {
      .best-price {
        display: none;
      }

      .sale.got-what-it-takes span {
        background-color: var(--accent);
        padding: 0 23px;
        border-radius: 5px;
      }
    }

    &.business {
      .users-holder {
        height: 28px;

        .caption {
          display: block;
          height: 18px;
        }

        small {
          display: block;
          line-height: 10px;
          font-weight: 500;
        }
      }
    }
  }

  &.got-what-it-takes-campaign.lms {
    padding: var(--spacing-32);

    .subscribe-annual {
      height: 40px;
      background: var(--main-yellow);
      border: none;
      color: var(--main-dark);

      &:hover {
        color: var(--main-dark);
        background-color: var(--main-yellow-shade-1);
      }

      &:active {
        color: var(--main-dark);
        background-color: var(--main-yellow-shade-2);
      }
    }

    ul li {
      margin-bottom: var(--spacing-8);

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  &.top-finance-training-campaign {
    &.annual {
      filter: drop-shadow(0 0 20px #036FFD);

      .promo-label span {
        background-color: var(--accent);
        padding: 0 var(--spacing-24);
      }

      .subscribe-annual {
        background-color: var(--main-yellow);
        border: none;
        letter-spacing: 0.02em;
        color: #000C1F;

        &:hover {
          background-color: var(--main-yellow-shade-1);
        }

        &:active {
          background-color: var(--main-yellow-shade-2);
        }
      }
    }

    &.lms {
      .subscribe-annual {
        height: 40px;
      }
    }
  }

  &.future-proof-2024-campaign,
  &.fast-track-2024-campaign {
    &.annual {
      .sale span {
        background-color: var(--extreme-blue-2);
        color: var(--main-dark);
      }

      .caption {
        color: var(--main-dark-light-4);

        .save-label {
          background-color: var(--main-dark-light-4);
          color: var(--main-light);
        }
      }

      .btn-future-proof-2024,
      .btn-fast-track-2024 {
        box-sizing: border-box;
        color: var(--main-dark);
        border: 2px solid var(--main-dark);
        background-color: var(--extreme-yellow);

        &.btn-lg {
          height: 58px;
        }

        &:not(.btn-lg) {
          height: 40px;
        }
      }

      ul li {
        background-image: url("../assets/svg/icon-checked-extreme-blue-2.svg");
        background-position: 0 3px;
      }
    }

    &.fast-track-2024-campaign.annual {
      .sale span {
        background-color: var(--accent);
        color: var(--main-light);
      }
    }
  }

  &.get-future-ready-campaign {
    z-index: 0;

    &.annual {
      .sale span {
        background-color: var(--extreme-blue);
        color: var(--main-dark);
      }

      .btn-primary {
        box-sizing: border-box;
        background-color: var(--extreme-yellow);
        border-color: var(--main-dark);
        color: var(--main-dark);
        border-width: 2px;

        &.btn-lg {
          height: 58px;
        }

        &:not(.btn-lg) {
          @include bp($bp-desktop) {
            height: 40px;
          }
        }
      }

      ul li {
        background-image: url("../assets/svg/icon-checked-extreme-blue-2.svg");
        background-position: 0 3px;
      }
    }
  }

  &.free.free-weeks-2024-campaign {
    &.ds {
      .best-price,
      ul li {
        .free-campaign-label {
          color: var(--main-dark);
          background-color: var(--extreme-blue);
        }
      }

      ul li {
        fill: var(--accent);
        background-image: url("../assets/svg/icon-checked-ds-accent.svg");
        background-position: 0 5px;
      }
    }

    .btn-hollow {
      background-color: #FAFF00;
      border-radius: 0;
      border: 2px solid var(--main-dark);
      color: var(--main-dark);
    }
  }

  &.annual.cyber-monday-2023-campaign {
    box-shadow: 5px 5px 0 0 var(--c-cm-2);

    .sale span {
      background-color: var(--c-cm-2);
      color: var(--main-dark);
    }

    .caption .save-label {
      background-color: rgba(37, 244, 238, 0.6) !important;
      color: var(--main-dark) !important;
    }

    .btn-primary {
      background-color: var(--c-cm-1);
      border: 2px solid var(--main-dark);
      color: var(--main-light);
      transition: all 50ms linear;

      &:hover {
        outline: 2px solid var(--main-dark);
      }
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-cm.svg") !important;
      background-position: 0 5px;
    }

    &.fa {
      box-shadow: 5px 5px 0 0 var(--c-cm-1);

      .sale span {
        color: var(--main-light);
      }

      .caption .save-label {
        background-color: rgba(25, 95, 245, 0.75) !important;
        color: var(--main-light) !important;
      }
    }

    &.extend .btn-primary {
      background-color: var(--c-cm-3);
      color: var(--main-dark);
    }
  }

  &.annual.black-friday-2023-campaign {
    box-shadow: 0 0 33px 0 rgba(255, 122, 0, 0.8), 0 0 37px 0 rgba(197, 2, 2, 0.5), 3px 2px 50px 0 rgba(255, 229, 0, 0.25);

    .sale span {
      background-color: var(--main-dark);
      color: var(--main-light);
    }

    .caption .save-label {
      background-color: var(--main-yellow) !important;
      color: var(--main-dark) !important;
    }

    .btn-primary {
      background-color: var(--c-bf-1);
      border: 2px solid var(--main-dark);
      color: var(--main-dark);
      transition: all 50ms linear;

      &:hover {
        outline: 2px solid var(--main-dark);
      }
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-bf.svg") !important;
      background-position: 0 5px;
    }
  }

  &.annual.most-wanted-2024-campaign {
    .sale span {
      background-color: var(--c-mw-1);
      color: var(--main-dark);
    }

    .caption .save-label {
      background-color: var(--c-mw-3) !important;
      color: var(--main-light) !important;
    }

    .btn-primary {
      background-color: var(--c-mw-2);
      border: 2px solid var(--main-dark);
      color: var(--main-dark);
      transition: all 50ms linear;

      &:hover {
        outline: 2px solid var(--main-dark);
      }
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-mw.svg") !important;
      background-position: 0 5px;
    }

    &.fa {
      .sale span {
        background-color: var(--c-mw-1);
        color: var(--main-light);
      }

      .caption .save-label {
        background-color: rgba(255, 54, 255, 0.7) !important;
        color: var(--main-dark) !important;
      }

      .btn-primary {
        border-radius: 0;
      }
    }
  }

  &.annual.transform-your-future-2024-campaign {
    .sale span {
      background-color: var(--c-tyf-1);
      color: var(--main-dark);
    }

    .caption .save-label {
      background-color: rgba(37, 244, 238, 0.6) !important;
      color: var(--main-dark) !important;
    }

    .btn-primary {
      background-color: var(--c-tyf-2);
      border: 2px solid var(--main-dark);
      color: var(--main-dark);
      transition: all 50ms linear;

      &:hover {
        outline: 2px solid var(--main-dark);
      }
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-tyf.svg") !important;
      background-position: 0 5px;
    }

    &.fa {
      .sale span {
        background-color: #195FF5;
        color: var(--main-light);
      }

      .caption .save-label {
        background-color: rgba(25, 95, 245, 0.75) !important;
        color: var(--main-light) !important;
      }
    }
  }

  &.annual.jumpstart-2025-campaign {
    z-index: 0;
    border-radius: 0;
    border: none;
    box-shadow: 0 0 63.7px 0 var(--c-js2025-3);

    .sale span {
      background-color: var(--c-cm2024-1);
      color: var(--main-dark);
      border-radius: 0;
    }

    .caption .save-label {
      background-color: var(--main-dark-light-4) !important;
      color: var(--main-light) !important;
      border-radius: 0;
    }

    .btn-primary {
      background-color: var(--c-bf2024-2);
      border: 2px solid var(--main-dark);
      border-radius: 0;
      color: var(--main-dark);
      transition: all 50ms linear;
      padding-left: 0;
      padding-right: 0;
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-extreme-magenta.svg") !important;
      background-position: 0;
    }

    &.fa {
      border: 4px solid var(--c-cm2024-3);
      box-shadow: 0 0 63.7px 0 var(--c-cm2024-3);

      .sale span {
        background-color: var(--c-cm2024-3);
        color: var(--main-light);
      }

      ul li {
        background-image: url("../assets/svg/icon-checked-extreme-orange.svg") !important;
      }
    }
  }

  &.annual.cyber-monday-2024-campaign {
    z-index: 0;
    border-radius: 0;
    border: 4px solid var(--c-cm2024-1);
    box-shadow: 0 0 63.7px 0 var(--c-cm2024-1);

    .sale span {
      background-color: var(--c-cm2024-1);
      color: var(--main-dark);
      border-radius: 0;
    }

    .caption .save-label {
      background-color: var(--main-dark-light-4) !important;
      color: var(--main-light) !important;
      border-radius: 0;
    }

    .btn-primary {
      background-color: var(--c-bf2024-2);
      border: 2px solid var(--main-dark);
      border-radius: 0;
      color: var(--main-dark);
      transition: all 50ms linear;
      padding-left: 0;
      padding-right: 0;
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-extreme-magenta.svg") !important;
      background-position: 0;
    }

    &.fa {
      border: 4px solid var(--c-cm2024-3);
      box-shadow: 0 0 63.7px 0 var(--c-cm2024-3);

      .sale span {
        background-color: var(--c-cm2024-3);
        color: var(--main-light);
      }

      ul li {
        background-image: url("../assets/svg/icon-checked-extreme-orange.svg") !important;
      }
    }
  }

  &.annual.black-friday-2024-campaign {
    z-index: 0;
    border: 4px solid var(--c-bf2024-1);
    box-shadow: 0 0 63.7px 0 var(--c-bf2024-1);

    .sale span {
      background-color: var(--c-bf2024-1);
      color: var(--main-light);
      border-radius: 0;
    }

    .caption .save-label {
      background-color: var(--main-dark-light-4) !important;
      color: var(--main-light) !important;
      border-radius: 0;
    }

    .btn-primary {
      background-color: var(--c-bf2024-2);
      border: 2px solid var(--main-dark);
      border-radius: 0;
      color: var(--main-dark);
      transition: all 50ms linear;
    }

    ul li {
      background-image: url("../assets/svg/icon-checked-extreme-red.svg") !important;
      background-position: 0;
    }
  }

  &.annual.learn-data-and-ai-campaign,
  &.annual.learn-finance-campaign {
    .sale span {
      background-color: var(--c-lda-2);
      color: var(--main-dark);
      border-radius: 0;
    }

    .caption .save-label {
      background-color: var(--main-dark-light-4) !important;
      color: var(--main-light) !important;
      border-radius: 0;
    }

    .btn-primary {
      background-color: var(--c-lda-1);
      border: 2px solid var(--main-dark);
      border-radius: 0;
      color: var(--main-dark);
      box-shadow: 6px 6px 0 0 var(--c-lda-2);
      transition: all 50ms linear;
    }

    &.ds {
      ul li {
        background-image: url("../assets/svg/icon-checked-extreme-blue-2.svg") !important;
        background-position: 0;
      }
    }

    &.fa {
      .sale span {
        background-color: #195FF5;
        color: var(--main-light);
      }

      .caption .save-label {
        background-color: rgba(25, 95, 245, 0.75) !important;
        color: var(--main-light) !important;
      }
    }

    &.extend {
      .btn-primary {
        box-shadow: 6px 6px 0 0 var(--c-lda-3);

        &:hover {
          box-shadow: 0 0 0 0 transparent;
        }
      }
    }
  }

  .spin-loader {
    height: 32px;
    line-height: 32px;
  }

  .spin {
    width: 32px;
    height: 32px;
    animation: spin 1.6s linear infinite;
  }

  .best-price,
  .best-value,
  .sale,
  .best {
    position: absolute;
    left: 0;
    top: -16px;
    width: 100%;
    display: flex;
    justify-content: center;

    span {
      padding: 0 10px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      color: var(--main-light);
      font-weight: 600;
    }

    &.trigger-label span {
      width: 148px;
      height: 33px;
      background: var(--main-red);
    }
  }

  .sale.platform span {
    background-color: var(--second-platform-accent);
  }

  .best-price {
    span {
      background-color: var(--accent);

      &.free-campaign-label {
        padding: 0 21px;
        background-color: var(--accent);
        line-height: 100%;
      }
    }
  }

  .best-value {
    span {
      background-color: var(--main-dark-light-4);
    }
  }

  .sale {
    &.loyalty-label {
      span {
        background-color: var(--second-platform-accent);
      }
    }

    span {
      background-color: var(--main-purple);
    }

    &.referral-label {
      span {
        background-color: var(--light-purple);
        color: #10141C;
      }
    }

    &.black-friday-label {
      span {
        background: var(--extreme-dark-blue);
        border-radius: 0;
      }
    }

    &.finance-courses-offer-label {
      span {
        width: 185px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0;
        background: #FC1E96;
        text-transform: uppercase;
      }
    }
  }

  .best {
    span {
      background-color: var(--main-dark-light-4);
    }
  }

  .h6 {
    color: var(--main-dark-shade-4);

    &.premium {
      color: var(--main-dark-shade-0);
    }
  }

  .h2 {
    margin-top: 28px;
    margin-bottom: var(--spacing-8);
    display: flex;

    .regular-price {
      display: inline-block;
      font-size: 14px;
      line-height: 100%;
      color: var(--main-dark-light-3);
      position: absolute;
      margin-top: -14px;

      &:before {
        content: '';
        top: 7px;
        left: 0;
        right: 0;
        position: absolute;
        height: 1px;
        width: 100%;
        background-color: var(--main-dark-light-4);
      }
    }

    .current-price {
      display: flex;
      align-items: flex-end;
      column-gap: var(--spacing-6);

      span {
        font-size: 18px;
        padding-bottom: 3px;

        &.small-text {
          font-weight: 400 !important;
          font-size: 18px !important;
        }
      }
    }

    .body-1 .body-2 {
      vertical-align: bottom;
    }
  }

  .caption {
    color: var(--main-dark-shade-4);
    display: flex;
    align-items: center;
    position: relative;

    .save-label {
      position: absolute;
      left: 100px;
      background: rgba(86, 191, 199, 0.2);
      border-radius: 3px;
      color: var(--accent);
      font-weight: 600;
      margin-left: var(--spacing-8);
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 24px;
      line-height: 24px;
      width: 81px;

      &.new-label {
        color: var(--main-yellow);
        background-color: rgba(237, 200, 67, 0.2);
      }

      &.trigger,
      &.collection,
      &.referral {
        color: var(--main-purple-dark-1);
        background: var(--main-purple-light-4) !important;
      }

      &.collection.simple-lms {
        color: var(--main-red);
        background: rgba(255, 160, 160, 0.5) !important;
      }
    }
  }

  hr {
    border-color: var(--main-light-shade-3);
    margin-top: 14px;
    margin-bottom: 14px;
  }

  button {
    margin: var(--spacing-24) 0;
    width: 100%;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      line-height: var(--spacing-24);
      padding-left: var(--spacing-24);
      margin-bottom: 10px;
      position: relative;
      background-image: url("../assets/svg/icon-checked.svg");
      image-rendering: -webkit-optimize-contrast;
      background-position: 0 5px;
      background-repeat: no-repeat;

      .free-campaign-label {
        width: 57px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: var(--accent);
        border-radius: 3px;
        font-weight: 700;
        font-size: 9px;
        color: var(--main-light);
        position: absolute;
        margin-left: 4px;
      }

      &.unselect {
        background-image: url("../assets/svg/icon-x.svg");
        image-rendering: -webkit-optimize-contrast;
        background-position: 2px 5px;
        color: var(--main-dark-opacity-40);

        &:before {
          opacity: 0;
        }
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .free-campaign-label {
      background-color: var(--extreme-blue);
      color: var(--main-dark-shade-0);
    }
  }

  .details {
    display: none;
  }

  .btn-hollow {
    background-color: var(--main-light-shade-1);
    border-width: 1px;

    &:hover {
      background-color: var(--accent-shade-1);
    }

    &:active {
      border-color: var(--accent-shade-2);
      background-color: var(--accent-shade-2);
    }
  }

  .btn-sale {
    border-color: var(--main-purple);
    color: var(--main-purple);

    &:hover {
      background-color: var(--main-purple);
      color: var(--main-light);
    }

    &:active {
      background-color: #2F1381;
      border-color: #2F1381;
      color: var(--main-light);
    }
  }

  .btn-cm {
    &:hover {
      background-color: var(--accent-shade-1);
    }

    &:active {
      background-color: var(--accent-shade-2);
    }
  }

  .btn-primary-sale {
    background-color: var(--main-purple);
    border-color: var(--main-purple);
    color: var(--main-light);

    &:hover {
      background-color: #2F1381;
    }

    &:active {
      background-color: #2F1381;
    }
  }

  .btn-referral {
    background-color: var(--main-purple-dark-1);
    border-color: var(--main-purple-dark-1);
    color: var(--main-light);

    &:hover {
      background-color: var(--main-purple-dark-3);
    }

    &:active {
      background-color: var(--main-purple-dark-4);
    }
  }

  .btn-collection {
    background-color: var(--main-yellow);
    border-color: var(--main-yellow);
    color: #10141C;

    &:hover {
      background-color: var(--main-yellow-shade-1);
    }

    &:active {
      background-color: var(--main-yellow-shade-2);
    }
  }

  .btn-lg {
    font-weight: 600;
    width: 100%;
  }

  .campaign-btn:not(.free-btn):not(.subscribe-monthly):not(.subscribe-annual):not(.subscribe-quarterly):not(.subscribe-business) {
    background: var(--main-yellow);
    border-color: transparent;
    color: var(--main-dark-shade-0);
    font-weight: 600;

    &:hover,
    &:active {
      background: var(--main-yellow-shade-2);
    }
  }

  .campaign-btn {
    font-weight: 600;
  }

  .trigger-offer-btn,
  .referral-offer-btn {
    height: 40px;

    &:hover {
      border: none;
      height: 40px;
    }
  }

  .collection-offer-btn {
    border: none;
    height: 40px;
    color: #10141C;
    background: var(--main-yellow);

    &:hover {
      border: none;
      height: 40px;
      background: var(--main-yellow-shade-1);
    }

    &:active {
      border: none;
      height: 40px;
      background: var(--main-yellow-shade-2);
    }
  }

  .loyalty-offer-btn {
    border: none;
    background: var(--accent);

    &:hover {
      background: var(--accent-shade-1);
    }

    &:active {
      background: var(--accent-shade-2);
    }
  }
}

@include bp($bp-laptop) {
  .card {
    &.lms:not(.v2) {
      padding: var(--spacing-48) var(--spacing-28) var(--spacing-28);

      .sale.collection-label {
        span {
          font-size: 14px;
          line-height: 27px;
        }
      }

      .h6 {
        font-size: 18px;

        &.premium {
          font-size: 21px;
        }
      }

      .h2 .current-price {
        font-size: 32px;
        line-height: 40px;
      }

      .current-price {
        .body-1 .body-2 {
          font-size: 12px;
        }
      }

      ul li {
        font-size: 14px;
        line-height: 23px;
      }
    }

    .h2 .current-price {
      height: 40px;
      font-size: 32px;

      span {
        font-size: 16px;
      }
    }

    button {
      margin: var(--spacing-16) 0;
    }

    .caption {
      font-size: 12px;
      line-height: 20px;
      margin-bottom: var(--spacing-10);

      .save-label {
        width: 74px;
        left: 85px;
      }
    }

    ul li {
      font-size: 12px;
      line-height: 18px;
    }

    &.v2 {
      padding: 24px;

      .h6 {
        font-size: 18px;

        &.premium {
          font-size: 21px;
        }
      }

      &.lms {
        .h6 {
          &,
          &.premium {
            font-size: 18px;
          }
        }
      }

      &:not(.lms) .best-price {
        span {
          font-size: 14px;
        }
      }

      .h2 .current-price {
        font-size: 28px;
      }

      .caption {
        height: 28px;
        line-height: 14px;
        display: flex;
        align-items: center;
      }

      &.business {
        .business-card-title {
          margin-top: 28px;
          font-size: 24px;
        }

        .business-card-subtitle {
          font-size: 12px;
          margin-top: 10px;
        }
      }

      .btn-primary {
        height: 50px;

        &.subscribe-annual {
          height: 54px;
          padding: 16px;
        }
      }
    }

    &.business {
      .business-card-title {
        margin-top: var(--spacing-10);
      }

      .business-card-subtitle {
        line-height: 130%;
      }

      .subscribe-business {
        margin-top: var(--spacing-16);
      }
    }

    &.one-of-two-hundred-2024-campaign.annual {
      &.lms {
        .button-holder.annual {
          top: -6px;

          &.manage {
            top: 16px;
          }
        }

        ul {
          padding-top: 72px;

          &.manage-plan-list {
            padding-top: var(--spacing-32);
          }
        }
      }
    }

    &.free-weeks-2024-campaign {
      ul li {
        .free-campaign-label {
          width: 55px;
          height: 18px;
          line-height: 18px;
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .card {
    padding: 46px var(--spacing-32) var(--spacing-32) var(--spacing-32);

    &.v2 {
      max-width: 328px;
      margin-left: auto;
      margin-right: auto;

      .details {
        margin-top: var(--spacing-16);

        &.expanded + ul {
          display: block;
        }
      }

      .best-price {
        top: -16px;
      }

      .h6,
      &.lms .h6,
      &.lms .h6.premium {
        font-size: 24px;
      }

      &:not(.lms) {
        .best-price span {
          font-size: 16px;
        }
      }

      &.annual {
        padding: 46px var(--spacing-32) var(--spacing-32) var(--spacing-32);

        &:after {
          top: 0;
          bottom: 0;
        }
      }

      .caption {
        font-size: 14px;
      }

      &.business {
        .h6 {
          color: var(--main-dark-light-4);
        }
      }

      &.lms {
        .best-price {
          top: -16px;
        }

        .manage-plan-details,
        .details {
          display: none;
        }
      }
    }

    &.lms:not(.v2) {
      &.sale {
        margin-top: var(--spacing-16);
      }

      .h2 {
        .regular-price {
          margin-top: -10px;
        }
      }

      .details {
        font-size: 16px;
      }

      hr {
        margin-top: var(--spacing-16);
        margin-bottom: 0;
      }
    }

    .h2 {
      .current-price {
        margin-top: var(--spacing-4);
        display: block;
        font-size: 40px;
      }
    }

    button {
      margin: var(--spacing-16) 0 var(--spacing-18) 0;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
    }

    ul {
      max-height: 0;
      overflow: hidden;
      transition: all var(--duration) ease;
      margin: 0;

      &.expanded {
        display: block;
        max-height: 1000px;
        margin-top: var(--spacing-16);
      }
    }

    .details {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: var(--main-dark-shade-4);
      transition: all var(--duration) ease;
      margin: 0;
      cursor: pointer;

      &.expanded {
        svg {
          transform: rotate(180deg);
        }
      }

      svg {
        margin-left: 10px;

        path[stroke] {
          stroke: var(--main-dark-shade-4);
        }
      }
    }

    &.finance-courses-offer-campaign {
      &.annual {
        filter: drop-shadow(0 0 18px #195FF5);
      }

      .btn-primary {
        height: 50px !important;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &.business {
      .users-holder .users-count .bubble {
        transform: translateX(0%);

        &:before {
          left: 95%;
        }
      }
    }

    .trigger-offer-btn,
    .collection-offer-btn,
    .referral-offer-btn {
      border: none;
      height: 50px;

      &:hover {
        border: none;
        height: 50px;
      }
    }

    &.one-of-two-hundred-2024-campaign.annual {
      .details {
        &.manage-plan-details {
          margin-top: var(--spacing-44);
        }
      }

      ul {
        padding-top: 0;
      }
    }

    &.top-finance-training-campaign.lms {
      .subscribe-annual {
        height: 50px;
      }
    }
  }
}

.fa {
  .card {
    .h2 .current-price .body-1 .body-2 {
      font-size: 16px;
    }

    ul {
      li:not(.unselect) {
        background-image: url("../assets/svg/fa/fa-icon-checked-blue.svg");
      }
    }

    .caption .save-label {
      background: rgba(3, 111, 253, 0.2);
    }

    .sale {
      &.loyalty-label {
        span {
          background-color: var(--second-platform-accent);
        }
      }
    }
  }

  @include bp($bp-laptop) {
    .card {
      .h2 .current-price {
        font-size: 32px;

        .body-1 {
          display: none;
        }

        .body-2 {
          font-size: 12px;
          display: block;
        }
      }

      .caption {
        margin-bottom: 0;
      }
    }
  }
}
</style>
